import { KeyboardEvent, useMemo, useState } from 'react';
import { useIsMobile } from '../_custom/Hooks/useIsMobile';
import { KEYBOARD_EVENTS } from '../../utils/constants/commonConstants';
import { buildSourceRows } from './utils';
import { SourceInput } from './types';

export const useSourcesInfoLabelLogic = (sources?: SourceInput[]) => {
    const isMobile = useIsMobile();
    const [sheetOpen, setSheetOpen] = useState(false);
    const rows = useMemo(() => buildSourceRows(sources), [sources]);

    const openSheet = () => setSheetOpen(true);
    const closeSheet = () => setSheetOpen(false);
    const onTriggerKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === KEYBOARD_EVENTS.ENTER || e.key === KEYBOARD_EVENTS.SPACE) {
            e.preventDefault();
            openSheet();
        }
    };

    return { rows, isMobile, sheetOpen, openSheet, closeSheet, onTriggerKeyDown };
};
